var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 504C392.967 504 504 392.967 504 256C504 119.033 392.967 8 256 8C119.033 8 8 119.033 8 256C8 392.967 119.033 504 256 504Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M455.015 403.798C431.886 372.832 401.853 347.688 367.302 330.364C332.752 313.039 294.637 304.012 255.986 304C217.336 303.988 179.215 312.991 144.654 330.294C110.092 347.597 80.0434 372.722 56.8945 403.674C79.9257 434.782 109.926 460.061 144.489 477.484C179.052 494.907 217.217 503.988 255.923 504C294.63 504.012 332.8 494.955 367.375 477.554C401.949 460.153 431.965 434.892 455.015 403.798Z",
    fill: "#7F9D48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 272C309.019 272 352 229.019 352 176C352 122.981 309.019 80 256 80C202.981 80 160 122.981 160 176C160 229.019 202.981 272 256 272Z",
    fill: "#7F9D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d862bcd4a0383a4c8603a583408a4254.svg";
export { ForwardRef as ReactComponent };